export interface IOrganization {
  id?: number;
}

export class Organization implements IOrganization {
  constructor(public id?: number) {}
}
